import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { WithParams } from '@utils/typescript';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { ActionRequest } from '@models/ActionRequest';

export type GetAllActionRequestParams = PaginationParams & WithParams<{
  subject_type: string;
  subject_id: number;
}>;

export type CreateActionRequestParams = WithParams<{
  subject_type: string;
  subject_id: number;
  title: string;
  body: string;
}>;

export type GetActionRequestParams = WithParams<{
  id: number;
}>;

export type UpdateActionRequestParams = GetActionRequestParams & WithParams<{
  status: string;
  title: string;
  body: string;
}>;

export class ActionRequestApi {
  static getAll = async (params: GetAllActionRequestParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/action_requests`, { params: snakes(params) })
      .then((response) => paginate(response) as [ActionRequest[], Pagination]);
  };

  static create = async (params: CreateActionRequestParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/user/action_requests`, snakes(params))
      .then((response) => humps(response.data) as ActionRequest);
  };

  static get = async ({ id }: GetActionRequestParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/action_requests/${id}`)
      .then((response) => humps(response.data) as ActionRequest);
  };

  static update = async ({ id, ...rest }: UpdateActionRequestParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/action_requests/${id}`, snakes(rest))
      .then((response) => humps(response.data) as ActionRequest);
  };
}
